module.exports = __webpack_public_path__ + "img/005-zombie.a2540595.png";